import React from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ensureReady, After, ServerAppState } from "@shopdeck/after";
import routes from "./routes";
import { App } from "./App";
import * as globals from "./services/globals";
import { CacheProvider } from "@emotion/react";
import createCache from '@emotion/cache';
import { UTMParamsType } from "typings/generics.type";
import { getCookieValue, getQueryParam } from "utils/helper";


// window.__PRELOADED_LOCALS__
export const store = (window['__PRELOADED_LOCALS__'] || {});

const extractFullUTMParamsFromURL = (): UTMParamsType => {
	if (typeof window === 'undefined') return {} as UTMParamsType;
	const urlParams = new URLSearchParams(window.location.search);
	const keys: (keyof UTMParamsType)[] = [
		'campaign_id', 'adgroupid', 'creative', 'keyword', 'targetid', 'placement',
		'adposition', 'network','device', 'devicemodel', 'matchtype', 'loc_physical_ms', 'gclid'
	];

	const result: UTMParamsType = {};
	keys.forEach((key) => {
		const val = urlParams.get(key);
		if (val) result[key] = val;
	});
	return result;
}

const utmParams = {
	...(store.utmParams || {}),
	...extractFullUTMParamsFromURL()
};

const visitorId = store.visitorId;
const sessionId = store.sessionId;
const device = store.device;

globals.set(globals.keys.utmParams, utmParams);
globals.set(globals.keys.visitorId, visitorId);
globals.set(globals.keys.sessionId, sessionId);
globals.set(globals.keys.device, device);
globals.set(globals.keys.sdSSOIPAddress, store.sdSSOIPAddress);

const fbclidURLParam = getQueryParam('fbclid');
const fbcFallback = fbclidURLParam ? `fb.1.${new Date().getTime()}.${fbclidURLParam}` : undefined;
const fbAnalyticsAttributes = {
  fbc: getCookieValue('_fbc') || fbcFallback,
  fbp: getCookieValue('_fbp')
};
globals.set(globals.keys.fbAnalyticsParams, fbAnalyticsAttributes);

function renderApp() {
	ensureReady(routes).then((data) => {
		const rootElement = document.getElementById("root");
		if (rootElement) {
			hydrateRoot(
				rootElement,
				<BrowserRouter>
					{/* <CacheProvider value={createCache({ key: 'css', prepend: true })}> */}
						<App>
							<After transitionBehavior='instant' customParams={{ locals: store }} data={data as unknown as ServerAppState} routes={routes} />
						</App>
					{/* </CacheProvider> */}
				</BrowserRouter>
			);
		} else {
			console.error("Root element not found");
		}
	});
}

renderApp();

if (module.hot) {
	module.hot.accept("./routes", renderApp);
}


/**
 *
 * <Routes>

						{routes.map((route, index) => {
							const Component = route.Component;
							return (
								<Route
									path={route.path}
									key={`route--${index}`}
									Component={() => {
										return (
											<Component
											/>
										)
									}}
								/>
							)
						})}
					</Routes>
 */
